"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderOf = exports.PlaceTypes = exports.ResourceTypes = exports.ResourceFile = exports.Forecast = void 0;
const economic_forecasting_1 = require("@oxfordeconomics/economic-forecasting");
class Forecast {
    constructor(Path, Id, Versions, Archived) {
        this.Path = Path;
        this.Id = Id;
        this.Versions = Versions;
        this.Archived = Archived;
    }
    get Type() { return ResourceTypes.Forecast; }
    get FileType() { return "Forecast"; }
    get LatestVersion() {
        if (!this.Versions.length) {
            console.error("Invalid forecast. Must have at least one version.");
        }
        return this.Versions.slice(-1)[0];
    }
    get LastModifiedAt() {
        return this.LatestVersion.CreatedAt;
    }
    get Range() {
        return this.LatestVersion.Range;
    }
    get Domain() {
        return this.LatestVersion.EconomicDomain;
    }
    get Periodicity() {
        return economic_forecasting_1.PeriodHelper.FrequencyOf(this.Range.From);
    }
    /** @deprecated Use Range.From instead */
    get StartDate() { return this.Range.From; }
    /** @deprecated Use Range.To instead */
    get EndDate() { return this.Range.To; }
    // Kept getting a runtime error when trying to declare these as abstract properties.
    get Archive() { return this.getArchiveOp(); }
    get Delete() { return this.getDeleteOp(); }
    get Rename() { return this.getRenameOp(); }
    get Restore() { return this.getRestoreOp(); }
}
exports.Forecast = Forecast;
class ResourceFile {
    constructor(Path, Id, Versions, Archived, FileType, MimeType) {
        this.Path = Path;
        this.Id = Id;
        this.Versions = Versions;
        this.Archived = Archived;
        this.FileType = FileType;
        this.MimeType = MimeType;
    }
    get Type() { return ResourceTypes.ResourceFile; }
    get LatestVersion() {
        if (!this.Versions.length) {
            console.error("Invalid file. Must have at least one version.");
        }
        return this.Versions.slice(-1)[0];
    }
    get LastModifiedAt() {
        return this.LatestVersion.CreatedAt;
    }
    // Kept getting a runtime error when trying to declare these as abstract properties.
    get Archive() { return this.getArchiveOp(); }
    get Delete() { return this.getDeleteOp(); }
    get Rename() { return this.getRenameOp(); }
    get Restore() { return this.getRestoreOp(); }
}
exports.ResourceFile = ResourceFile;
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes[ResourceTypes["Folder"] = 0] = "Folder";
    ResourceTypes[ResourceTypes["Forecast"] = 1] = "Forecast";
    ResourceTypes[ResourceTypes["ResourceFile"] = 2] = "ResourceFile";
})(ResourceTypes = exports.ResourceTypes || (exports.ResourceTypes = {}));
exports.PlaceTypes = ["MyResources", "OurResources", "Releases", "LocalDrive", "MyArchive", "AllUsers", "AllOrganizations"];
/** The folder behind a location, if there is one. Resources can only be created in, or moved into, a folder. */
function FolderOf(location) {
    return (location === null || location === void 0 ? void 0 : location.Type) === ResourceTypes.Folder ? location : null;
}
exports.FolderOf = FolderOf;
//# sourceMappingURL=resources.js.map